// @ts-nocheck
import { LABEL_CONFIG } from '../const/LabelConfigs/labelConfig';
import { LABEL_CONFIG_DYNAMIC_LABELING_TEST } from '../const/LabelConfigs/labelConfigDynamicLabelingTest';
import { LABEL_CONFIG_FCRA } from '../const/LabelConfigs/labelConfigFCRA';
import { LABEL_CONFIG_HDFC } from '../const/LabelConfigs/labelConfigHdfc';
import { LABEL_CONFIG_AI_GOVERNANCE } from '../const/LabelConfigs/labelConfigAIGovernance';
import { LABEL_CONFIG_07 } from '../const/LabelConfigs/labelConfig07';
const TENANTS_MAPPING_FOR_LABEL_CONFIG = {
  fcra_vault: LABEL_CONFIG_FCRA,
  revamp_fcra: LABEL_CONFIG_FCRA,
  revamp_ewra: LABEL_CONFIG_FCRA,
  hdfcbank: LABEL_CONFIG_HDFC,
  dynamic_labeling: LABEL_CONFIG_DYNAMIC_LABELING_TEST,
  vault_sandbox01: LABEL_CONFIG_AI_GOVERNANCE,
  vault_sandbox07: LABEL_CONFIG_07,
};

export const getLabelConfigFile = () => {
  const ORG = () => {
    const org = localStorage.getItem('REALM_ID');

    return org;
  };

  const currentTenant = ORG();

  if (TENANTS_MAPPING_FOR_LABEL_CONFIG[currentTenant]) {
    return TENANTS_MAPPING_FOR_LABEL_CONFIG[currentTenant];
  }
  return LABEL_CONFIG;
};
